const navigation = document.querySelector('#main-navigation');
const navigationToggle = document.querySelector('#toggle-navigation');
const sublevelToggle = document.getElementsByClassName('toggle-sublevel');

let lastNavigationState = 'inactive';  // inactive | active

let lastKnownScrollPosition = 0;
let ticking = false;

function changeNavbarClass(scrollPosition){
	if(scrollPosition > 0) {
		// add Class
		navigation.classList.add('scrolled');
	} else {
		navigation.classList.remove('scrolled');
	}
}

function toggleNavigationClass(){
	if(navigation.classList.contains('inactive')) {
		navigation.classList.remove('inactive');
		navigation.classList.add('active');
	} else {
		navigation.classList.remove('active');
		navigation.classList.add('inactive');
	}
}

toggleNavigationClass();

function toggleSubLevel(target){
	target.classList.toggle('active');
}

document.addEventListener('scroll', () => {
	lastKnownScrollPosition = window.scrollY;

	if(!ticking) {
		window.requestAnimationFrame(() => {
			changeNavbarClass(lastKnownScrollPosition);
			ticking = false;
		});
		ticking = true;
	}
});

navigationToggle.addEventListener('click', () => {
	toggleNavigationClass();
});
for (let i = 0; i < sublevelToggle.length; i++) {
	sublevelToggle[i].addEventListener('click', function(){
		toggleSubLevel(this);
	});
}


